<script setup>
import { Link, usePage } from "@inertiajs/vue3";
import { onMounted, ref } from "vue";
import ContactColumn from "./ContactColumn.vue";

const props = defineProps({
  description: String
});

const zorgblikSupportMail = ref("");
const zorgblikPhoneNumber = ref("");
const zorgblikCompanyName = ref("");
const zorgblikStreetAddress = ref("");
const zorgblikZipCity = ref("");

onMounted(async () => {
  zorgblikSupportMail.value = usePage().props.zorgblik_support_email;
  zorgblikPhoneNumber.value = usePage().props.zorgblik_phone_number;
  zorgblikCompanyName.value = usePage().props.zorgblik_company_name;
  zorgblikStreetAddress.value = usePage().props.zorgblik_street_address;
  zorgblikZipCity.value = usePage().props.zorgblik_zip_city;
});
</script>

<template>
  <div class="text-base">
    <p v-if="description">{{ description }}</p>

    <ContactColumn :title="$t('Call')" v-if="zorgblikPhoneNumber">
      <Link
        :href="'tel:' + zorgblikPhoneNumber"
        class="block transition-colors duration-300 hover:text-orange"
      >{{ zorgblikPhoneNumber }}</Link>
    </ContactColumn>

    <ContactColumn :title="$t('E-mail')" v-if="zorgblikSupportMail">
      <Link
        class="block transition-colors duration-300 hover:text-orange"
        :href="'mailto:' + zorgblikSupportMail"
      >{{ zorgblikSupportMail }}</Link>
    </ContactColumn>

    <ContactColumn :title="$t('Address')" v-if="zorgblikCompanyName">
      <p>{{ zorgblikCompanyName }}</p>
      <p>{{ zorgblikStreetAddress }}</p>
      <p>{{ zorgblikZipCity }}</p>
    </ContactColumn>
  </div>
</template>
